export interface ComicItem {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  status: 'ongoing' | 'completed';
  rating: number;
  views: string;
  favorites: string;
  chapters: number;
  latestChapter: string;
  description: string;
  tags: string[];
}

export interface Testimonial {
  id: string;
  name: string;
  avatar: string;
  role: string;
  content: string;
}

export const hotRankingComics: ComicItem[] = [
  {
    id: 'secretarys-temptation',
    title: '秘书的诱惑',
    author: 'KIM作家',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20romance%20office%20love%20story%2C%20beautiful%20female%20character%20in%20elegant%20office%20attire%2C%20warm%20coral%20and%20pink%20color%20palette%2C%20soft%20romantic%20atmosphere%2C%20professional%20digital%20illustration%2C%20clean%20composition%20with%20soft%20lighting&width=800&height=1100&seq=hot-ranking-01&orientation=portrait',
    category: '恋爱甜宠',
    status: 'ongoing',
    rating: 9.6,
    views: '3280万',
    favorites: '156万',
    chapters: 128,
    latestChapter: '第128话',
    description: '职场恋爱物语，高冷总裁与可爱秘书之间的甜蜜拉扯。画风精美细腻，剧情甜到爆炸，是2026年最受期待的韩漫之一。',
    tags: ['职场', '恋爱', '甜宠'],
  },
  {
    id: 'sword-legend',
    title: '剑之传奇',
    author: 'PARK画师',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20martial%20arts%20action%20adventure%2C%20male%20warrior%20with%20sword%20in%20dynamic%20pose%2C%20dramatic%20lighting%20with%20warm%20orange%20and%20red%20tones%2C%20epic%20fantasy%20atmosphere%2C%20professional%20digital%20art%2C%20action%20scene%20composition&width=800&height=1100&seq=hot-ranking-02&orientation=portrait',
    category: '热血冒险',
    status: 'ongoing',
    rating: 9.4,
    views: '2150万',
    favorites: '98万',
    chapters: 96,
    latestChapter: '第96话',
    description: '少年持剑闯荡江湖，热血沸腾的战斗场面，复杂的人物关系，每一话都让人欲罢不能。华丽的剑技特效，震撼的视觉体验。',
    tags: ['武侠', '热血', '战斗'],
  },
  {
    id: 'midnight-detective',
    title: '午夜侦探',
    author: 'LEE编剧',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20mystery%20detective%20thriller%2C%20dark%20atmospheric%20city%20night%20scene%2C%20mysterious%20silhouette%20figure%2C%20deep%20teal%20and%20dark%20blue%20color%20scheme%2C%20suspenseful%20mood%2C%20professional%20digital%20illustration%2C%20noir%20aesthetic&width=800&height=1100&seq=hot-ranking-03&orientation=portrait',
    category: '悬疑推理',
    status: 'completed',
    rating: 9.8,
    views: '4560万',
    favorites: '210万',
    chapters: 156,
    latestChapter: '第156话（完结）',
    description: '天才侦探与连环杀手的终极对决。扣人心弦的悬疑剧情，令人窒息的推理过程，堪称韩漫悬疑类巅峰之作。',
    tags: ['悬疑', '推理', '犯罪'],
  },
];

export const latestComics: ComicItem[] = [
  {
    id: 'campus-love',
    title: '校园恋爱手册',
    author: 'CHOI作者',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20school%20romance%20youth%20love%20story%2C%20cute%20students%20in%20school%20uniform%2C%20cherry%20blossom%20spring%20atmosphere%2C%20soft%20pink%20and%20cream%20color%20palette%2C%20sweet%20romantic%20vibe%2C%20professional%20digital%20illustration&width=800&height=1100&seq=latest-01&orientation=portrait',
    category: '恋爱甜宠',
    status: 'ongoing',
    rating: 9.2,
    views: '890万',
    favorites: '45万',
    chapters: 42,
    latestChapter: '第42话',
    description: '青涩的校园恋情，从暗恋到双向奔赴的甜蜜故事。',
    tags: ['校园', '恋爱', '青春'],
  },
  {
    id: 'dungeon-warrior',
    title: '地下城勇士',
    author: 'JUNG漫画家',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20fantasy%20dungeon%20adventure%2C%20warrior%20in%20armor%20with%20glowing%20weapon%2C%20epic%20game%20world%20background%2C%20vibrant%20warm%20orange%20and%20gold%20tones%2C%20dynamic%20action%20pose%2C%20professional%20digital%20art&width=800&height=1100&seq=latest-02&orientation=portrait',
    category: '热血冒险',
    status: 'ongoing',
    rating: 9.1,
    views: '720万',
    favorites: '38万',
    chapters: 68,
    latestChapter: '第68话',
    description: '游戏世界中的冒险故事，打怪升级，热血激战。',
    tags: ['游戏', '冒险', '升级'],
  },
  {
    id: 'warm-cafe',
    title: '温暖的咖啡馆',
    author: 'PARK编剧',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20cozy%20cafe%20healing%20slice%20of%20life%2C%20warm%20coffee%20shop%20interior%20with%20soft%20lighting%2C%20comforting%20atmosphere%2C%20cream%20and%20beige%20warm%20tones%2C%20relaxing%20peaceful%20vibe%2C%20professional%20digital%20illustration&width=800&height=1100&seq=latest-03&orientation=portrait',
    category: '治愈日常',
    status: 'ongoing',
    rating: 9.5,
    views: '1560万',
    favorites: '87万',
    chapters: 88,
    latestChapter: '第88话',
    description: '街角咖啡馆里发生的温暖故事，每一杯咖啡都有一个动人的故事。',
    tags: ['治愈', '日常', '美食'],
  },
  {
    id: 'magic-academy',
    title: '魔法学院',
    author: 'KANG画师',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20magic%20academy%20fantasy%2C%20young%20mage%20student%20with%20magical%20sparks%2C%20mystical%20school%20castle%20background%2C%20teal%20and%20emerald%20green%20color%20scheme%2C%20enchanting%20atmosphere%2C%20professional%20digital%20art&width=800&height=1100&seq=latest-04&orientation=portrait',
    category: '奇幻异界',
    status: 'ongoing',
    rating: 9.3,
    views: '1830万',
    favorites: '102万',
    chapters: 112,
    latestChapter: '第112话',
    description: '普通少年意外进入魔法学院，开启了一段不可思议的魔法之旅。',
    tags: ['魔法', '学院', '奇幻'],
  },
];

export const testimonials: Testimonial[] = [
  {
    id: 'testi-1',
    name: '小雨同学',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20with%20warm%20smile%2C%20casual%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20professional%20but%20friendly%20vibe%2C%20Korean%20style%20fashion%2C%20beauty%20portrait%20photography&width=400&height=400&seq=testi-avatar-01&orientation=squarish',
    role: '资深读者',
    content: '自从发现了韩漫漫画网，我每天都要来这里看更新。画风精美，翻译质量高，最重要的是完全免费！推荐给所有喜欢韩漫的朋友。',
  },
  {
    id: 'testi-2',
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%20with%20gentle%20smile%2C%20modern%20casual%20style%2C%20warm%20studio%20lighting%2C%20clean%20minimal%20background%2C%20friendly%20approachable%20expression%2C%20professional%20portrait%20photography&width=400&height=400&seq=testi-avatar-02&orientation=squarish',
    role: '漫画爱好者',
    content: '更新速度真的太快了，几乎是同步更新。分类也很清晰，找漫画特别方便。下拉式阅读体验特别流畅，完全沉浸式看漫画。',
  },
  {
    id: 'testi-3',
    name: '阿琳爱看漫画',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20with%20bright%20happy%20smile%2C%20trendy%20Korean%20fashion%2C%20soft%20warm%20lighting%2C%20clean%20pastel%20background%2C%20cheerful%20friendly%20expression%2C%20beauty%20lifestyle%20portrait&width=400&height=400&seq=testi-avatar-03&orientation=squarish',
    role: '忠实粉丝',
    content: '找了很久的冷门韩漫这里居然都有！智能推荐也特别准，推荐给我的几部漫画我全都爱上了。已经安利给身边所有朋友了。',
  },
];

export const categories = [
  { slug: 'romance', name: '恋爱甜宠', icon: 'ri-heart-line', count: 2580 },
  { slug: 'action', name: '热血冒险', icon: 'ri-sword-line', count: 1920 },
  { slug: 'mystery', name: '悬疑推理', icon: 'ri-search-eye-line', count: 860 },
  { slug: 'healing', name: '治愈日常', icon: 'ri-cup-line', count: 1250 },
  { slug: 'fantasy', name: '奇幻异界', icon: 'ri-magic-line', count: 1680 },
  { slug: 'drama', name: '都市剧情', icon: 'ri-building-line', count: 970 },
];